module.exports = __webpack_public_path__ + "static/media/banner-promocao.dcfcedfe.png";